import { property as initialState } from 'flux/initialState';
import { property as actions } from 'flux/actions';
import { validateProfilingConsent } from 'utils';

export default function (state = initialState, action) {
  const { types } = actions;

  switch (action.type) {
    case types.RESET: {
      const { resetState } = action.payload;
      return { ...resetState, fetched: true };
    }
    case types.TOGGLE_PROFILING_CONSENT: {
      const { profilingConsent } = action.payload;

      return {
        ...state,
        extras: { ...state.extras, profiling_consent: validateProfilingConsent(profilingConsent) },
      };
    }
    default:
      return state;
  }
}
